/**
* author: duxin
* date: 2020/4/8
* describe: 新闻
*/

<template>
    <div>
        <div class="news-title">
            <p class="p1">{{info.title}}
            </p>
            <!--日期-->
            <p class="p1 date">
                {{info.publishDate}}
                <span>{{typeFilter(info.type)}}</span>
            </p>
            </div>
        <div v-if="isShow" style="text-align: center">
            <img style="margin-top: 30vh;width: 150px;" src="../../assets/loading.gif" alt="">
        </div>
        <div class="news" v-else>
            <!--图片-->
            <template v-if="info.imageUrl">
                <div style="text-align: center">
                    <img class="news-cover" :src="info.imageUrl">
                </div>
            </template>
            <template v-else>
                <el-carousel :interval="3000" type="card" class="carousel-img" height="300px">
                    <el-carousel-item v-for="item in info.imageUrlList">
                        <div style="text-align: center;height: 100%">
                            <img class="cover-img" :src="item.imageUrl">
                        </div>
                    </el-carousel-item>
                </el-carousel>
            </template>

            <!--日期-->
            <!-- <p class="date">
                {{info.createTime}}
                <span>{{typeFilter(info.type)}}</span>
            </p> -->
            <!--富文本内容-->
            <div class="content ql-snow ql-editor" v-html="info.introduction"></div>
        </div>
    </div>
</template>

<script>
    import {GetBookInfo, GetNewsInfo} from "../../api/web";
    import moment from "moment"

    export default {
        name: "web-page",
        data() {
            return {
                info: {},
                isShow: true,
            }
        },
        created() {
            this.typeInfo = {
                0:  this.$t("menu.company"),
                1:  this.$t("menu.industry"),
                2:  this.$t("menu.book")
            };
            if (this.bookId) {
                this.getBook()
            } else if (this.newsId) {
                this.getNews()
            }
        },
        methods: {
            getBook() {
                GetBookInfo(this.bookId).then(res => {
                    if (res.status) {
                        this.info = {
                            title: res.data.bookName,
                            imageUrlList: res.data.bookPicPOList,
                            createTime: moment(res.data.createTime).format("YYYY/MM/DD"),
                            type: 2,
                            introduction: res.data.introduction
                        }
                        this.$nextTick(() => {
                            this.isShow = false;
                        })
                    }else {
                        this.$router.push({name:"BOOK"})
                    }
                })
            },
            getNews() {
                GetNewsInfo(this.newsId).then(res => {
                    if (res.status) {
                        this.info = {
                            title: res.data.title,
                            imageUrl: res.data.imageUrl,
                            createTime: moment(res.data.createTime).format("YYYY/MM/DD"),
                            type: res.data.newsType,
                            introduction: res.data.content
                        }
                        this.$nextTick(() => {
                            this.isShow = false;
                        })
                    } else {
                        this.$router.push({name:"COMPANY"})
                    }
                })
            },
            typeFilter(type) {
                return this.typeInfo[type]
            }
        },
        computed: {
            bookId() {
                return this.$route.query.bookId
            },
            newsId() {
                return this.$route.query.newsId
            }
        }
    }
</script>

<style lang="less" scoped>
    @import "../../style/constant.less";

    .news {
        // width: @page-width;
        width: 792px;
        margin: 0 auto;
        padding: 30px 10px;

        .carousel-img {
            width: 50%;
            margin: 0 auto;
        }

        .cover-img {
            height: 100%;
            max-width: 90%;
        }

        .news-cover {
            max-height: 300px;
            max-width: 80%;
        }
    }

    .news-title {
        background-color: #f6f6f6;
        padding: 15px 15px 15px 0;
        // padding-left: (~"(10calc0% - @page-width) / 2");
        .p1 {
            width: 792px;
            margin: 0 auto;
            font-size: 26px;
        }
        .date {
            margin-top: 10px;
            color: @active-color;
            font-size: 14px;
        }
    }

    .content {
        margin-top: 15px;

        img {
            max-width: 300px;
        }
    }

    @media screen and (min-width: 320px) and (max-width: 480px) {
        .news {
            width: 95%;

            .carousel-img {
                width: 90%;
            }
        }

        .news-title {
            padding: 15px;
            .p1 {
                width: 100%;
            }
        }
    }

</style>
